import apiSlice from "./ApiSlice";

export const moduleApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // GET ALL
    getAllModules: builder.query({  
      providesTags:['module'] ,
      query: () => {
        return {
          url: "/module",
          method: "GET",
        };
      },
    }),

    // Get Module Filter Pagination
   getModulePagination : builder.query({ 
    providesTags:['module'] ,
      query: (body) => {
        return {
          url: '/module',
          method: 'POST',
          body,
        };
      },
    }), 

   // Add
   addModule: builder.mutation({
    invalidatesTags: ["module"],
    query: (body:any) => {
      return {
        url: "/module/add",
        method: "POST",
        body,
      };
    },
  }),

    // Delete
    deleteModule: builder.mutation({ 
      invalidatesTags: ["module"],
    query: (id:string) => {
      return {
        url: `/module/${id}`,
        method: 'DELETE',
      };
    },
  }),
  //Edit
  editModule: builder.mutation({
    invalidatesTags: ["module"],
     query: ({body ,id}:any) => {
      return {
        url: `/module/${id}`,
        method: "PUT",
        body,
      };
    },
  }),
  //Single View
  viewModule: builder.query({
    providesTags: ["module"],
     query: (id:any) => {
      return {
        url: `/module/${id}`,
        method: "GET",
      };
    },
  }),
  }),
});

export const { useGetAllModulesQuery , useGetModulePaginationQuery , useDeleteModuleMutation ,useAddModuleMutation , useEditModuleMutation , useViewModuleQuery } = moduleApi;
